import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { Grid as InavistaGrid, GridConfig, GridRowsSelectedEvent } from '@inavista/components/grid';
import { CommonService } from '../../services/common.service';
import { exportInavistaGrid } from '../../utils/inavista-grid-export';
import { LocalRowsGridApi, provideLocalGridRows } from '../../utils/local-rows-grid-api';
import { InventoryService } from 'projects/service/src/app/modules/home/services/inventory.service';
import { buildLinkServiceOrdersGridConfig, LINK_SERVICE_ORDERS_COLUMNS } from './link-service-orders.grid.config';

// The old grid's content was window.innerHeight - 330 tall, with its toolbar and header above it.
// The inavista grid draws them inside its own box.
const GRID_CHROME_PX = 92;

@Component({
    selector: 'app-link-service-orders-popup',
    templateUrl: './link-service-orders-popup.component.html',
    styleUrls: ['./link-service-orders-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    // The grid reads this.ServiceOrdersForTransferOrder, not an endpoint.
    providers: [...provideLocalGridRows()]
})

export class LinkServiceOrdersPopupComponent implements OnInit {
  isExpanded: boolean = false;
  showLoader: boolean = false;
  title: string = "Link Service Orders";
  hideCreationDate: boolean = true;
  ServiceOrdersForTransferOrder: any = [];
  USER;

  gridHeight: number = window.innerHeight - 330 + GRID_CHROME_PX;
  gridConfig: GridConfig = null;

  @ViewChild('linkServiceOrdersGrid') linkServiceOrdersGrid: InavistaGrid;
  // The ticked orders (serviceOrderId): the old getSelectedRecords().
  serviceOrderIdtosend = [];
  private readonly gridRows = inject(LocalRowsGridApi);

  @Input() technicianId = '';
  @Input() selectedServiceOrderIDs = [];

  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() serviceOrderIdArray: EventEmitter<any> = new EventEmitter();

  constructor(
    private commonService: CommonService,
    private inventoryService: InventoryService
  ) {
    this.USER = commonService.USER;
  }
  ngOnInit(): void {
    this.showLoader = true;
    this.gridRows.columns.set(LocalRowsGridApi.schema(LINK_SERVICE_ORDERS_COLUMNS));
    this.gridConfig = buildLinkServiceOrdersGridConfig(!!this.commonService.roleClaims['AllGrid_Toolbar_Excel_Export']?.visible);
    this.getData();
  }

  getData() {
    if (this.technicianId) {
      this.inventoryService.getServiceOrdersForTransferOrder(this.technicianId).subscribe((res: any) => {
        if (res.isSuccessful) {
          this.ServiceOrdersForTransferOrder = res.result;
          this.refreshRows();
        } else {
          this.commonService.showNotification('error', res.message);
        }
        this.showLoader = false;
      }, error => {
        this.showLoader = false;
        this.commonService.showNotification('error', error.message);
      });
    }
  }

  // The rows the grid shows, then the orders already linked ticked (the old dataBound).
  // Fixed (Martin, 2026-10-28): the old grid ticked them again after every filter and search, by row index in the
  // unsorted list, so it dropped the user's own ticks and could tick another row; ticks are now kept by order number.
  private refreshRows() {
    const rows = Array.isArray(this.ServiceOrdersForTransferOrder) ? this.ServiceOrdersForTransferOrder : [];
    this.gridRows.rows.set(rows.map(so => ({ ...so })));
    this.linkServiceOrdersGrid?.refresh();
    const known = new Set(rows.map(so => so.serviceOrderId));
    this.serviceOrderIdtosend = (this.selectedServiceOrderIDs ?? []).filter(id => known.has(id));
    this.linkServiceOrdersGrid?.setCheckedKeys(this.serviceOrderIdtosend, { emit: false });
  }

  onRowsSelected(event: GridRowsSelectedEvent) {
    this.serviceOrderIdtosend = event.rows.map(row => row['serviceOrderId']);
  }

  add() {
    this.serviceOrderIdArray.emit(this.serviceOrderIdtosend);
    this.close();
  }

  close() {
    this.onClose.emit();
  }

  expandCollapse(value: boolean) {
    this.isExpanded = value;
  }

  // The old Excel export: the rows the grid shows, the visible columns, "Link Service Order(<date>).xlsx".
  onExportRequested() {
    exportInavistaGrid(this.linkServiceOrdersGrid, 'Link Service Order');
  }

}
